// src/plugins/axios.js
import axios from 'axios';
// FIX: Change to relative path
import store from '../store'; 
// FIX: Change to relative path
import router from '../router'; 

// Backend API URL
export const BACKEND_URL = process.env.VUE_APP_BACKEND_URL || 'http://localhost:8765';

// create axios instance
const api = axios.create({
  baseURL: BACKEND_URL,
  timeout: 120000
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

api.interceptors.request.use(
  config => {
    const token = store.getters['auth/accessToken'] || localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  err => Promise.reject(err)
);

api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    // Prompt 3: Global quota error handling
    if (error?.response?.status === 402 && error?.response?.data?.error === 'quota_exceeded') {
      const message = error.response.data.message || 'Quota exceeded. Please upgrade your plan.';
      store.dispatch('ui/showToast', { message, type: 'error' });
      // Optionally open the upgrade modal
      store.dispatch('ui/openUpgradeModal');
      return Promise.reject(error);
    }

    // if 401 or 403 (token expired) and not retry yet
    if (error.response && (error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
      // Prevent infinite loop: if the logout request fails, don't try to refresh
      if (originalRequest.url.includes('/auth/logout')) {
        return Promise.reject(error);
      }

      if (isRefreshing) {
        // queue the request
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return api(originalRequest);
        }).catch(err => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newAccessToken = await store.dispatch('auth/refreshAccessToken');
        processQueue(null, newAccessToken);
        originalRequest.headers['Authorization'] = 'Bearer ' + newAccessToken;
        return api(originalRequest);
      } catch (err) {
        processQueue(err, null);
        // refresh failed, logout the user
        store.dispatch('auth/logout');
        // Only redirect to login if the current route requires authentication
        const currentRoute = router.currentRoute.value;
        if (currentRoute.meta?.requiresAuth) {
          router.push({ name: 'LoginPage' });
        }
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
